import { render, staticRenderFns } from "./CardBlock.vue?vue&type=template&id=eaaaa540&scoped=true&"
import script from "./CardBlock.vue?vue&type=script&lang=js&"
export * from "./CardBlock.vue?vue&type=script&lang=js&"
import style0 from "./CardBlock.vue?vue&type=style&index=0&id=eaaaa540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaaaa540",
  null
  
)

export default component.exports